// Resolves the signed-in user to their Personnel record by matching their email
// against Personnel.email or .login_email (case-insensitive) — the same email
// bridge the backend uses to stamp "created by" on incidents.
//
// Callers get { loading, person, me, email, hasIdentity }. Everything degrades
// gracefully: with auth off (local dev) or before sign-in there is no email, so
// `person` is null and `hasIdentity` is false; a signed-in user with no matching
// Personnel row also yields person = null (but hasIdentity = true).
import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "./config";
import { useCurrentUser } from "./useCurrentUser";

export function useMyPersonnel(enabled = true) {
  const me = useCurrentUser();
  const email = (me.email || "").trim().toLowerCase();
  const [state, setState] = useState({ loading: enabled && !!email, person: null });

  useEffect(() => {
    if (!enabled || !email) { setState({ loading: false, person: null }); return; }
    let active = true;
    setState({ loading: true, person: null });
    axios.get(`${API_BASE_URL}/personnel/`)
      .then(res => {
        if (!active) return;
        // Either address: `email` is the record's own once /me has linked them,
        // but the sign-in address until then (see useCurrentUser).
        const matches = (v) => (v || "").trim().toLowerCase() === email;
        const person = res.data.find(p => matches(p.email) || matches(p.login_email)) || null;
        setState({ loading: false, person });
      })
      .catch(() => { if (active) setState({ loading: false, person: null }); });
    return () => { active = false; };
  }, [enabled, email]);

  return { me, email, hasIdentity: !!email, ...state };
}
